/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformSettingsResponseAdminDto } from '../../models/platform-settings-response-admin-dto';
import { UpdateSocialLinksDto } from '../../models/update-social-links-dto';

export interface AdminPlatformSettingsControllerUpdateSocialLinksV1$Params {
      body: UpdateSocialLinksDto
}

export function adminPlatformSettingsControllerUpdateSocialLinksV1(http: HttpClient, rootUrl: string, params: AdminPlatformSettingsControllerUpdateSocialLinksV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformSettingsResponseAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminPlatformSettingsControllerUpdateSocialLinksV1.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformSettingsResponseAdminDto>;
    })
  );
}

adminPlatformSettingsControllerUpdateSocialLinksV1.PATH = '/v1/admin/platform-settings/social-links';
